export default __webpack_public_path__ + "static/media/109.d1673e6b.jpg";